import changeCase from 'change-case'
import uniqueId from 'lodash/uniqueId'
import PropTypes from 'prop-types'
import { AnalyticsConsumer } from '@opallabs/quanta'
import Token from '../../Token'
import { kuiperClassNames, kuiperClassNamesWithTracking } from '../../utils'
import * as styles from './styles'

const sanitizeOption = (option) => {
  if (option.type === 'users') {
    return { id: option.id, fullName: option.fullName }
  }
  return option.title
}

const badgeList = []

const getBadge = (title) => {
  const hasBadge = badgeList.find((badgeObj) => badgeObj.title === title)

  if (hasBadge) return hasBadge.badge

  return null
}

const OptionToken = ({
  avatared,
  disableKuiperStyles,
  isHighlighted,
  isSelected,
  onMouseEnter,
  onSelect,
  option,
  role,
  showDeselectIcon,
  style,
  theme,
  tooltip,
}) => {
  const title = changeCase.paramCase(option.title)
  const badge = getBadge(title)
  const select = (track) => {
    const sanitizedOption = sanitizeOption(option)
    track('select', { option: sanitizedOption })
    onSelect(option)
  }

  const disabled = (option || {}).disabled || false
  const htmlId = uniqueId('kuiper-virtuallist-token')

  return (
    <AnalyticsConsumer>
      {({ track }) => (
        <div
          aria-current={role === 'menuitem' ? isSelected : null}
          aria-disabled={disabled}
          aria-selected={role === 'menuitem' ? null : isSelected}
          className={kuiperClassNamesWithTracking(
            disableKuiperStyles || 'menu-option-token',
            { tracking: `option-${title}` }
          )}
          css={disableKuiperStyles ? styles.container({ theme }) : null}
          role={role}
          style={style}
          tabIndex={0}
        >
          <Token
            {...option}
            aria-labelledby={htmlId}
            htmlId={htmlId}
            title={option.title || option.fullName || option.full_name}
            userId={avatared ? option.id : undefined}
            selected={isSelected}
            className={kuiperClassNames(disableKuiperStyles || 'menu-option', {
              isHighlighted,
            })}
            onClick={() => select(track)}
            onMouseEnter={onMouseEnter}
            avatared={avatared}
            badge={badge}
            tooltip={tooltip}
            showDeselectIcon={showDeselectIcon}
            removable={showDeselectIcon}
            theme={theme}
          />
        </div>
      )}
    </AnalyticsConsumer>
  )
}
OptionToken.displayName = 'Kuiper: OptionToken ← Menu'

OptionToken.defaultProps = {
  disableKuiperStyles: false,
  onMouseEnter: () => {},
  role: 'menuitem',
  theme: 'light',
  showDeselectIcon: false,
}

OptionToken.propTypes = {
  avatared: PropTypes.bool,
  disableKuiperStyles: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isSelected: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.object,
  role: PropTypes.oneOf(['menuitem', 'option']),
  showDeselectIcon: PropTypes.bool,
  style: PropTypes.object,
  theme: PropTypes.oneOf(['dark', 'light']),
  tooltip: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
    PropTypes.string,
  ]),
}

export default OptionToken
